//
// A privilege gate answers 200 with { notAllowed: true } rather than an error
// status, so that a client asking for what it may not do never feeds the ban
// path. Every caller of a gated route reads this before using the answer.
//
const answerRefusesPrivilege = (res) => (res?.body?.rslt?.data?.[0]?.notAllowed === true);

export default answerRefusesPrivilege;
